export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/08ee3b32e72dd5b2b700754671ea2016.svg";